import React from 'react';
import { Link } from '../PlatformFunctionality';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

interface TextWithLinksProps {
  message: string;
  replacements: { [key: string]: string };
  as?: keyof JSX.IntrinsicElements;
  onClick?: () => void;
}

export const TextWithLinks = ({ message, replacements, as: Component = 'div', onClick }: TextWithLinksProps) => {
  const sanitizedMessage = message?.replace(/<\/?[^>]+(>|$)/g, '');
  const createLinkedText = (text: string) => {
    let elements = [text];
    Object.keys(replacements).forEach(key => {
      const regex = new RegExp(key, 'i');
      const temp: Array<string | JSX.Element> = [];
      elements.forEach(el => {
        if (typeof el === 'string') {
          const parts = el.split(regex);
          parts.forEach((part, index) => {
            temp.push(part);
            if (index !== parts.length - 1) {
              const matchedKey = el.match(regex)?.[0];
              temp.push(
                <Link
                  style={{ color: palette.primary.dark }}
                  key={key + index}
                  href={replacements[key]}
                  onClick={onClick}
                >
                  {matchedKey}
                </Link>
              );
            }
          });
        } else {
          temp.push(el);
        }
      });
      elements = temp as Array<string>;
    });
    return <Component>{elements}</Component>;
  };
  return <>{createLinkedText(sanitizedMessage)}</>;
};
